import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { SaveLibraryDataPayload } from '../../../models';

@Component({
  selector: 'save-library-data-modal',
  templateUrl: './save-library-data-modal.component.html'
})
export class SaveLibraryDataModalComponent implements OnInit {

  @Input() modalTitle: string;
  @Input() libraryDataNameLabel: string;
  @Input() libraryDataNameRequiredErrorMsg: string;
  @Input() libraryDataNameExistsErrorMsg: string;

  @Input() checkIfLibraryDataNameExists: (templateName: string) => Observable<boolean>;
  @Input() saveLibraryData: (payload: SaveLibraryDataPayload) => Observable<void>;
  @Input() closeModal: () => void;

  saveLibraryDataForm: FormGroup;
  isSaveDisabled: boolean;
  doesLibraryDataNameExist: boolean;

  constructor(private _formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.saveLibraryDataForm = this._formBuilder.group({
      libraryDataName: ['', Validators.required]
    });
  }

  getLibraryDataNameControl(): AbstractControl { return this.saveLibraryDataForm.get('libraryDataName'); }

  onSave(): void {
    this.getLibraryDataNameControl().markAsTouched();

    if (this.saveLibraryDataForm.valid) {
      this.isSaveDisabled = true;

      const templateName: string = this.getLibraryDataNameControl().value;

      this.checkIfLibraryDataNameExists(templateName).subscribe({
        next: (doesNameExist: boolean) => {
          this.doesLibraryDataNameExist = doesNameExist;

          if (!doesNameExist) {
            this.saveChosenLibraryData();
          } else {
            this.isSaveDisabled = false;
          }
        },
        error: () => this.isSaveDisabled = false
      });
    }
  }

  onClose(): void {
    this.closeModal();
  }

  private saveChosenLibraryData(): void {
    const payload: SaveLibraryDataPayload = { templateName: this.getLibraryDataNameControl().value };

    this.saveLibraryData(payload)
      .pipe(finalize(() => this.isSaveDisabled = false))
      .subscribe();
  }

}
